import { html } from "../../render";
import { attr, cn, safeRandomId, spreadAttrs } from "../../utils";
import { LpButton } from "../../components/button";
import { LpCollapsible } from "../../components/collapsible";
import { LpGrid } from "../../components/grid";
import { LpIcon } from "../../components/icon";
export const LP_MODULE_GRID_COLUMNS = [1, 2, 3, 4];
export const LP_MODULE_GRID_ICON_TONES = [
    "default",
    "success",
    "warning",
    "danger",
    "info",
];
const gridManagedAttrs = [
    "data-lp-block",
    "class",
    "data-columns",
];
const headingManagedAttrs = [
    "class",
];
const sectionManagedAttrs = [
    "class",
    "data-lp-module-grid-section",
    "data-expanded",
    "data-icon-tone",
    "aria-labelledby",
];
function getGridVariant(columns) {
    return `${columns}up`;
}
export function LpModuleGrid({ children, columns = 2, className, attributes, }) {
    return html `
        <lp-module-grid
            data-lp-block="ModuleGrid"
            class="${cn("lp-module-grid", className, attributes?.class)}"
            data-columns="${columns}"
            ${spreadAttrs(attributes, { omit: gridManagedAttrs })}
        >
            ${LpGrid.Root({
        children,
        variant: getGridVariant(columns),
        className: "lp-module-grid_layout",
    })}
        </lp-module-grid>
    `;
}
export function LpModuleGridHeading({ children, className, attributes, }) {
    return html `
        <h2
            class="${cn("lp-module-grid_heading", className, attributes?.class)}"
            ${spreadAttrs(attributes, { omit: headingManagedAttrs })}
        >
            ${children}
        </h2>
    `;
}
export function LpModuleGridSection({ title, children, label, icon, iconWeight = "regular", iconTone = "default", expanded = true, className, attributes, }) {
    const id = safeRandomId();
    const titleId = `lp-module-grid-section-title-${id}`;
    const sectionLabel = label ?? (typeof title === "string" ? title : "section");
    return html `
        <section
            class="${cn("lp-module-grid_section", className, attributes?.class)}"
            data-lp-module-grid-section
            ${attr("data-expanded", expanded)}
            data-icon-tone="${iconTone}"
            aria-labelledby="${titleId}"
            ${spreadAttrs(attributes, { omit: sectionManagedAttrs })}
        >
            ${LpCollapsible.Root({
        open: expanded,
        attributes: {
            "data-lp-module-grid-section-label": sectionLabel,
        },
        trigger: (context) => html `
                    <div class="lp-module-grid_section-header">
                        <div class="lp-module-grid_section-heading">
                            ${LpIcon({
            name: icon,
            weight: iconWeight,
            className: "lp-module-grid_section-icon",
        })}
                            <h2 id="${titleId}" class="lp-module-grid_section-title">${title}</h2>
                        </div>
                        ${LpCollapsible.Trigger({
            ...context,
            label: sectionLabel,
            openText: "Collapse",
            closedText: "Expand",
            className: "lp-module-grid_section-toggle",
        })}
                    </div>
                `,
        panel: (context) => LpCollapsible.Panel({
            ...context,
            children: LpGrid.Root({
                variant: "1up",
                className: "lp-module-grid_section-grid",
                children,
            }),
        }),
    })}
        </section>
    `;
}
export function LpModuleGridItem({ children, expanded = false, className, attributes, }) {
    return LpGrid.Item({
        children,
        expanded,
        className: cn("lp-module-grid_item", className),
        attributes: {
            ...attributes,
            "data-lp-module-grid-item": true,
        },
    });
}
export function LpModuleGridExpandButton({ label, className, attributes, }) {
    return LpButton({
        ariaLabel: `Expand ${label}`,
        label: html `
            <span class="lp-module-grid_expand-icon" data-state="collapsed" aria-hidden="true">
                ${LpIcon({ name: "arrows-out-simple", size: 14 })}
            </span>
            <span class="lp-module-grid_expand-icon" data-state="expanded" aria-hidden="true">
                ${LpIcon({ name: "arrows-in-simple", size: 14 })}
            </span>
        `,
        size: "sm",
        shape: "square",
        variant: "ghost",
        className: cn("lp-module-grid_expand", className),
        attributes: {
            ...attributes,
            "data-lp-module-grid-expand": label,
            "aria-expanded": "false",
            title: `Expand ${label}`,
        },
    });
}
